<template>
  <div>
    <my-header-mobile/>
    <my-header/>
    <notice/>
    <page-five/>
    <my-footer/>
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader'
import MyHeaderMobile from '@/components/MyHeaderMobile'
import Notice from '@/components/notice'
import MyFooter from '@/components/Footer'
import router from "@/router";
import PageFive from "@/components/PageFive";

export default {
  name: "DetailFive",
  components: {
    PageFive,
    MyFooter,
    MyHeader,
    MyHeaderMobile,
    Notice
  },
  mounted() {
    router.afterEach((to, from, next) => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    })
  }
}

</script>

<style scoped>

</style>
